/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TeamWithVideoDto } from '../../models/team-with-video-dto';

export interface ScoutingControllerGetTeamsWithVideo$Params {
}

export function scoutingControllerGetTeamsWithVideo(http: HttpClient, rootUrl: string, params?: ScoutingControllerGetTeamsWithVideo$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TeamWithVideoDto>>> {
  const rb = new RequestBuilder(rootUrl, scoutingControllerGetTeamsWithVideo.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TeamWithVideoDto>>;
    })
  );
}

scoutingControllerGetTeamsWithVideo.PATH = '/scouting/teams';
